import axios from 'axios';
import customAxios from '../../../../utils/customAxios';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWarning,
  faCircleChevronLeft,
} from '@fortawesome/free-solid-svg-icons';
import '../../../../scss/Components/_modal.scss';
import { toast } from 'react-toastify';
import { GlobalVariables } from '../../../../globalVar';
import { getToast } from '../../../../utils/toastConfig';

function ModalCMultDelete(props) {
  let idList = [];
  let clientDeleteList = localStorage.getItem('clientMultipleDeleteList');
  if (clientDeleteList !== null && clientDeleteList !== undefined) {
    idList = clientDeleteList
      .replace(/\[|\]|\'/g, '')
      .split(',')
      .map(Number);
  }

  const deleteClients = () => {
    customAxios
      .patch(
        `${GlobalVariables.getURL()}multipleDeleteClients`,
        { idList },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        }
      )
      .then((response) => {
        console.log(response.data);
        hideS();
      })
      .catch((error) => {
        console.error(error);
        getToast({
          status: 'error',
          title: 'Error al eliminar Plaza(s). Vuelve a intentarlo.',
        });
      });
  };

  function hideS() {
    props.onHide();
    getToast({
      status: 'success',
      title: 'Plaza(s) eliminado(s) exitosamente en la base de datos.',
    });
    props.getClients();
  }

  function hideN() {
    props.onHide();
  }

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      backdropClassName="modal-backdrop"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="modal-title" id="contained-modal-title-vcenter">
          ¿Quieres borrar estas Plazas?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {idList.map((id) => (
          <span>
            <strong>ID de la Plaza:</strong> {id}
            <br />
          </span>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <button
          className="modal-button"
          onClick={() => {
            deleteClients();
          }}
        >
          <FontAwesomeIcon icon={faWarning} /> Si, quiero eliminar esto.
        </button>
        <button
          className="modal-button no"
          onClick={() => {
            hideN();
          }}
        >
          <FontAwesomeIcon icon={faCircleChevronLeft} /> No, regrésame a la
          tabla.
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalCMultDelete;
